import { FormGroup, Button, Label, TextField } from '@celltrak/ui-components';

import { celltrakLogo, evvLogo } from '../../../Common/assets';
import { loginFormText } from '../../constants';

import LoginAlert from './LoginAlert';
import styles from './LoginForm.module.scss';
import useLoginForm from './hooks';

function LoginForm() {
  const {
    setUsername,
    setPassword,
    alertType,
    isVisible,
    handleFormSubmission,
    closeAlertHandler,
  } = useLoginForm();

  return (
    <div className={styles.loginForm}>
      <img alt="EVV Logo" src={evvLogo} />
      <LoginAlert alertType={alertType} showAlert={isVisible} onClose={() => closeAlertHandler()} />
      <form>
        <h2>{loginFormText.welcomeMsg}</h2>
        <h5>{loginFormText.enterLoginMsg}</h5>
        <FormGroup id="userGroup" class={styles.formWidth}>
          <Label for="username">{loginFormText.usernameLabel}</Label>
          <TextField
            id="username"
            onChange={({ target }) => setUsername(target.value)}
            type="text"
          />
        </FormGroup>
        <FormGroup id="passwordGroup" class={styles.formWidth}>
          <Label for="password">{loginFormText.passwordLabel}</Label>
          <TextField
            id="password"
            onChange={({ target }) => setPassword(target.value)}
            type="password"
          />
        </FormGroup>
        <div className={styles.actions}>
          <a id="forgotPassword" href="/login">
            {loginFormText.forgotPasswordLink}
          </a>
          <Button id="submitButton" type="submit" size="lg" onClick={handleFormSubmission}>
            {loginFormText.loginButton}
          </Button>
        </div>
      </form>
      <footer>
        <img alt="Celltrak Logo" src={celltrakLogo} />
        <div>{loginFormText.copyright}</div>
      </footer>
    </div>
  );
}

export default LoginForm;
